import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import getBillingGeneralSettings, { ErrorResponse, SuccessResponse } from "@custom/rtk-apis/billing/getGeneralSettings";

interface BillingState {
  status: string;
  result: any;
  msg: string;
  loading: boolean;
  error: string | ErrorResponse;
}

const initialState: BillingState = {
  status: "",
  result: null,
  msg: "",
  loading: false,
  error: "",
};

const getBillingGeneralSettingsSlice = createSlice({
  name: "getBillingGeneralSettingsSlice",
  initialState,
  reducers: {
    clearGeneralSettings: (state) => {
      state.status = "";
      state.result = null;
      state.msg = "";
      state.loading = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBillingGeneralSettings.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(
        getBillingGeneralSettings.fulfilled,
        (state, action: PayloadAction<SuccessResponse>) => {
          state.loading = false;
          state.status = action.payload.status || "";
          state.result = action.payload.data || action.payload;
          state.msg = action.payload.msg || "";
          state.error = "";
        }
      )
      .addCase(
        getBillingGeneralSettings.rejected,
        (state, action: PayloadAction<ErrorResponse | undefined>) => {
          state.loading = false;
          if (action.payload) {
            state.status = action.payload.status || "error";
            state.result = null;
            state.msg = action.payload.msg || "An error occurred";
            state.error = action.payload;
          } else {
            state.status = "error";
            state.msg = "Unknown error occurred";
            state.error = "Unknown error";
          }
        }
      );
  },
});

export default getBillingGeneralSettingsSlice.reducer;
export const { clearGeneralSettings } = getBillingGeneralSettingsSlice.actions;
